export enum LocalStorageKey {
  AUTOLOGIN = 'autoLogin',
  REFRESHTOKEN = 'refreshToken',
  ACCESSTOKEN = 'accessToken',
  ISLOGIN = 'isLogin',
  HOSPITAL_ID = 'hospitalId',
}
